import * as React from 'react';

import { translate } from '~l10n/client';

import { AlertMessage } from '~shared/components/AlertMessage';
import { useSelectedTeamPermissionQuery } from '~teacher/components/PricingTable/hooks';

export function ViewingPricingPlanWithoutPermission() {
  const teamSubscriptionsPermissionQuery = useSelectedTeamPermissionQuery();

  if (!teamSubscriptionsPermissionQuery.data) {
    return null;
  }

  const { canOpenStripeCheckout, canOpenStripePortal } =
    teamSubscriptionsPermissionQuery.data;

  if (!canOpenStripeCheckout || !canOpenStripePortal) {
    return (
      <AlertMessage tone="caution" align="center" showIcon>
        {translate('Ask a Team Admin or Owner to upgrade this team’s plan.')}
      </AlertMessage>
    );
  }

  return null;
}
